import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface EmbedNameDTO {
  name: string;
}

export class EmbedName {
  readonly isEmbedNameEmbedName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "minSize": 4,
      "maxSize": 128,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    EmbedName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: EmbedNameDTO): EmbedName {
    const name = getString(dto, "name", InvalidEmbedNameNameError);
    return new EmbedName(
      name
    );
  }

  toDTO(): EmbedNameDTO {
    const dto: EmbedNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length < 4) {
      throw new InvalidEmbedNameNameMinSizeError(
        4,
        `Attribute name is too short. Size is ${name.length}. Min size is 4.`
      );
    }
    if(name.length > 128) {
      throw new InvalidEmbedNameNameMaxSizeError(
        128,
        `Attribute name is too long. Size is ${name.length}. Max size is 128.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidEmbedNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

EmbedName.prototype.toString = function toString(): string {
  return `EmbedName(name='${this.name}')`;
};

export class InvalidEmbedNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedNameError";
  }
}
export class InvalidEmbedNameNameError extends InvalidEmbedNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedNameNameError";
  }
}

export class InvalidEmbedNameNameMaxSizeError extends InvalidEmbedNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedNameNameMaxSizeError";
  }
}

export class InvalidEmbedNameNameMinSizeError extends InvalidEmbedNameNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedNameNameMinSizeError";
  }
}

export class InvalidEmbedNameNameNonEmptyError extends InvalidEmbedNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidEmbedNameNameNonEmptyError";
  }
}
